module.exports = __webpack_public_path__ + "static/media/DE.88e525cc.svg";